<script>
import { DropDownButtonComponent } from "@syncfusion/ej2-vue-splitbuttons";

export default DropDownButtonComponent;
</script>

<style lang="scss">
$accent: #1976d2;
@import '~@syncfusion/ej2-buttons/styles/material.scss';
@import '~@syncfusion/ej2-popups/styles/material.scss';
@import '~@syncfusion/ej2-splitbuttons/styles/material.scss';
</style>
